/**
 * 全局下载工具
 * @file down-lode.js
 * @author baibangyi(baibangyi@baidu.com)
 */

/* global SYNC */

/**
 * downLoad
 * 数据下载
 *
 * @param {Object} opt 参数
 * @param {Object} opt.params 下载连接参数，必填
 * @param {Object} opt.baseUrl 下载接口地址，eg:教育-数据分析：/vmbi/plugin/dailydownload，必填
 * @param {string} opt.dotUrl 线下环境地址，通常为rd环境地址,eg: http//10.408.90.baidu.com，选填
 * @param {string} opt.noMerchants_id 教育merchants_third_id 选填
 * @param {string} opt.userid 教育userid 选填
 */
export function downloadTool(params, baseUrl, dotUrl = 'https://basic-service.baidu.com', noMerchants_id = '', userid = '') {
    let dotBaseUrl = 'https://basic-service.baidu.com';
    // 非线上环境
    dotBaseUrl = dotUrl;
    const url = `${dotBaseUrl}${baseUrl}`;
    const routerName = window.location.pathname.split('/')[4];
    const origin = process.env.NODE_ENV === 'development' ? 'http://lvlin.baidu.com' : window.location.origin;
    let downloadUrl = origin
                        + '/bp/plugin/proxy/get_file?'
                        + 'url='
                        + url
                        + '&params='
                        + JSON.stringify(params);
    downloadUrl = encodeURI(downloadUrl);
    window.location.href = downloadUrl;
}

/**
 * 下载文件并命名
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export function downloadFile(url, filename) {
    getBlob(url, function (blob) {
        saveAs(blob, filename);
    });
}
function getBlob(url, cb) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
        if (xhr.status === 200) {
            cb(xhr.response);
        }
    };
    xhr.send();
}
/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
function saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
    }
    else {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);
    }
}
